import React, { useEffect, useState, useCallback, useRef } from "react";

import { useSelector } from "react-redux";
import ModalPortal from "../../../util/component/Modal";
const TRIANGLE_RED = '#F84F31';
const TRIANGLE_GREEN = '#23c552';
const autoResizeTextarea = (e) => {
    let textarea = e
    if (textarea) {
        textarea.style.height = "12px";
        let height = textarea.scrollHeight; // 높이
        if (height < 12) {
            height = 12;
        }
        textarea.style.height = `${height}px`;
    }
};


const Rows = ({ api, code, rowData, index, PROCode ,onOpen,dataIndex,sheetType,RevCmptCheckList}) => {


/*    const clearActive = () => {
        setTemp(prev => prev.map(p => ({
            ...p,
            active: false
        })))
    }*/



    const remark = rowData?.find((search) => {
        return search.name === "remark"
    })
    const remark_chk = remark?.value !== "FALSE";

    const checkHide = rowData?.find((search) => {
        return search.name === "hide"
    })

    let cnt = 0;
    const [ModalOpen, SetModalOpen] = useState(false);
    const [ModalMsg, SetModalMsg] = useState(<p></p>);
    const HandleModalOpen = (type) => {
        if (type === "temp") SetModalMsg(<p>preview</p>);
        else SetModalMsg("");
        SetModalOpen(!ModalOpen);
    };
    // urs 62번, Admin 권한만 hide 된거 보여주기 (32 ~ 35번째 줄까지 추가)
    const userSelector = useSelector((store) => store.user);

    const uniqueCode = rowData.find(data=>data.name ==='uniqueCode').value;
    const sheetReview = RevCmptCheckList !== undefined ? RevCmptCheckList.filter(sheet => sheet.uniqueCode ===uniqueCode) : undefined;


    let revRowData = [];




    rowData.map((data,i) =>{
        const celNm = sheetReview !== undefined ? sheetReview.find(v => data.name=== v.celNm) : undefined;
        if(celNm !== undefined){
            data =  { ...data,cmptCheck:true, cmptType:celNm.cmptType ==='R' ? TRIANGLE_RED : TRIANGLE_GREEN} ;
        }else{
            data =  { ...data,cmptCheck:false } ;
        }
        revRowData = [...revRowData ,...[data]]
    } )


    if (checkHide?.value === "TRUE" && !userSelector.isAdmin) {
        return null
    } else {
        return (
            <>
                <tr rowSpan={remark_chk ? "2" : "1"}>
                    <td rowSpan={remark_chk ? "2" : "1"} >{index + 1}</td>

                    {revRowData.map((vv, ii) => {


                        if (vv.type === "checkbox" ||vv.type === "hidden") {
                            return null

                        }else if (vv.type === "select") {
                            cnt++;
                            if (vv.options === "sample") {
                                return <td onClick={() =>onOpen(vv,uniqueCode)} key={index + "" + ii} className={!!!vv.label ? "no-text" : ""} style={{cursor:"pointer",backgroundColor: vv.active ? "#eee" : "", position: "relative",overflow: "hidden"}}>
                                    {vv.cmptCheck ? <div style={{position: "absolute", backgroundColor: vv.cmptType, top: 0, right: 0, width: 16, height: 16, transform: "translateX(7px) translateY(-7px) rotateZ(45deg)"}}></div> : ""}
                                    <span>{vv.label}</span>
                            </td>
                            } else {
                                return <td onClick={() =>onOpen(vv,uniqueCode)} key={index + "" + ii} className={!!!vv.value ? "no-text" : ""} style={!!vv.style ? {...vv.style,cursor:"pointer", backgroundColor: vv.active ? "#eee" : "", overflow: "hidden"} : {cursor:"pointer",backgroundColor: vv.active ? "#eee" : "", overflow: "hidden"}}>
                                    {vv.cmptCheck ? <div style={{position: "absolute", backgroundColor: vv.cmptType, top: 0, right: 0, width: 16, height: 16, transform: "translateX(7px) translateY(-7px) rotateZ(45deg)"}}></div> : ""}
                                    <span>{vv.value}</span>
                            </td>
                            }
                        } else {
                            cnt++;
                            return <td onClick={() =>onOpen(vv,uniqueCode)} key={index + "" + ii} className={!!!vv.value ? "no-text" : ""} style={vv.borderStyle ? {...vv.borderStyle,cursor:"pointer", backgroundColor: vv.active ? "#eee" : "",overflow: "hidden"} : {cursor:"pointer",backgroundColor: vv.active ? "#eee" :"",overflow: "hidden"}}>
                                {vv.cmptCheck ? <div style={{position: "absolute", backgroundColor: vv.cmptType, top: 0, right: 0, width: 16, height: 16, transform: "translateX(7px) translateY(-7px) rotateZ(45deg)"}}></div> : ""}
                                {vv.value}
                        </td>
                        }
                    })}
                </tr>
                <tr className={(remark_chk ? "" : "d-none")}>
                    <td colSpan={cnt} style={{textAlign: "left"}}>
                        {remark?.value}
                    </td>
                </tr>
{/*                {ModalOpen && (
                <ModalPortal>
                    <OnReview onClose={HandleModalOpen}>{ModalMsg}</OnReview>
                </ModalPortal>
                )}*/}
            </>

        )
    }
}

export default React.memo(Rows);
